module.exports = __webpack_public_path__ + "img/rockstaripphonerender1_00069.9af20da.png";